export default function HomeFourAbout(){
    return(
        <>
        <section className="about-us-area pt-105 pb-75 pt-md-60 pb-md-30 pt-xs-60 pb-xs-75 home-4">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-lg-6">
						<div className="about-text-wrapper2 mb-30 pr-80">
							<h6 className="semi-title">Discover Our Company</h6>
							<h2 className="sect-title mb-35">Bringing New IT Business Solutions</h2>
							<ul className="text-list list-none">
								<li>
									<div className="services-list">
										<h5 className="fs-20">Engaging Group Discussion</h5>
										<p>Automotive has sought to change the way customers think about
											auto service by providing knowledgeable</p>
									</div>
								</li>
								<li>
									<div className="services-list mb-0">
										<h5 className="fs-20">Software Engineering</h5>
										<p>Automotive has sought to change the way customers think about
											auto service by providing knowledgeable</p>
									</div>
								</li>
							</ul>
							<div className="paragraph-title2">We help our clients succeed by creating brand identities,
								digital xperiences, and print materials.</div>
							<h6 className="about-author2">Alonso D. Wilimton <span className="text-vilet">-Head Of Idea </span>
							</h6>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="about-img-wrapper mb-30">
							<img className="w-100 img-one-a d-block d-xxl-none" src="assets/img/about/about-1.jpg" alt="About Img"/>
							<img className="img-one img-fluid d-none d-xxl-inline-block" src="assets/img/about/about-3.jpg" alt="About Img"/>
							<img className="img-two img-fluid d-none d-xxl-inline-block" src="assets/img/about/about-4.jpg" alt="About Img"/>
							<div className="experience-box">
								<div className="count-text2 text-center mb-30">
									<h3><span className="counter">30</span>
										<span className="prefix">+</span>
									</h3>
									<span className="title"> Years Experiences</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}